import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import Quiz from './Quiz';
import Entrance from './Entrance';

const QuizApp = () => {
  const [quizStarted, setQuizStarted] = useState(false);

  const handleStart = () => {
    setQuizStarted(true);
  };

  return (
    <>
      {!quizStarted ? (
        <Entrance onStart={handleStart} />
      ) : (
        <Quiz />
      )}
    </>
  );
};

const container = document.getElementById('quiz-root');
if (container) {
  const root = createRoot(container);
  root.render(<QuizApp />);
}
